import { getService } from 'azure-devops-extension-sdk';
import { getClient } from 'azure-devops-extension-api';
import {
  WorkItemErrorPolicy,
  WorkItemTrackingRestClient,
  WorkItemTrackingServiceIds,
} from 'azure-devops-extension-api/WorkItemTracking';
import { Item, ItemTypes } from '../../@types/domain';
import { WorkItemTypes } from '../../@types/azure';

const FIELD_TITLE = 'System.Title';
const ITEM_TYPE = 'System.WorkItemType';
const MICROSOFT_HIDDEN_WIT_CATEGORY = 'Microsoft.HiddenCategory';

const getItemsByIds = async (itemIds: number[]): Promise<Item[]> => {
  const hasItems = itemIds.length > 0;
  if (!hasItems) {
    return [];
  }
  const client = getClient(WorkItemTrackingRestClient);
  const workItems = await client.getWorkItems(
    itemIds,
    undefined,
    undefined,
    undefined,
    undefined,
    WorkItemErrorPolicy.Omit
  );
  return workItems.filter(Boolean).map<Item>((workItem) => ({
    id: workItem.id,
    name: workItem.fields[FIELD_TITLE],
    type: workItem.fields[ITEM_TYPE],
  }));
};

const createItem = async (_projectId, name, workItemType) => {
  const dialogService = await getService(
    WorkItemTrackingServiceIds.WorkItemFormNavigationService
  );
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return dialogService.openNewWorkItem(workItemType.name, {
    title: name,
  });
};

const openItemDialog = async (itemId: number, isNewTab?: boolean) => {
  const dialogService = await getService(
    WorkItemTrackingServiceIds.WorkItemFormNavigationService
  );
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return dialogService.openWorkItem(itemId, isNewTab);
};

const getProjectWorkItemTypes = (
  projectId: string
): Promise<WorkItemTypes[]> => {
  const client = getClient(WorkItemTrackingRestClient);
  return client.getWorkItemTypes(projectId);
};

const getHiddenWorkItemTypes = (projectId: string) => {
  const client = getClient(WorkItemTrackingRestClient);
  return client.getWorkItemTypeCategory(
    projectId,
    MICROSOFT_HIDDEN_WIT_CATEGORY
  );
};

const getWorkItemTypes = async (projectId: string): Promise<ItemTypes[]> => {
  const [projectWorkItemTypes, hiddenWorkItemTypes] = await Promise.all([
    getProjectWorkItemTypes(projectId),
    getHiddenWorkItemTypes(projectId),
  ]);

  const hiddenWorkItemTypesNames = new Set(
    hiddenWorkItemTypes.workItemTypes.map((workItemType) => workItemType.name)
  );
  return projectWorkItemTypes
    .filter((workItemType) => !hiddenWorkItemTypesNames.has(workItemType.name))
    .map((workItemType) => ({
      id: workItemType.referenceName,
      name: workItemType.name,
      iconUrl: workItemType.icon.url,
    }));
};
const getItemTypes = (projectId: string) => getWorkItemTypes(projectId);

export { getItemsByIds, createItem, openItemDialog, getItemTypes };
